import React, { useState, useEffect } from 'react';
import {auth, firestore, storage, arrayUnion, Timestamp} from '../firebase';

var UserStateContext = React.createContext();
var UserDispatchContext = React.createContext();
var UserContext = React.createContext();

function userReducer(state, action) {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return { ...state, isAuthenticated: true };
    case "SIGN_OUT_SUCCESS":
      return { ...state, isAuthenticated: false };
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function UserProvider({ children }) {
  const [user, setUser] = useState(null);
  const [userInformation, setUserInformation] = useState({
    avatar: null,
    name: null,
    email: null,
    admin: null,
    accountCreated: null,
    surveyCompleted: null,
    dashboard: [],
    survey: [],
  });
  const [files, setFiles] = useState(null);
  const [Loading, setLoading] = useState(true);

  useEffect(() => {
    const subscriber = auth.onAuthStateChanged(onAuthStateChanged);
    return subscriber;
  }, []);

  const onAuthStateChanged = user => {
    if (user){
      setUser(user);

      firestore
        .collection('Users')
        .doc(user.uid)
        .get()
        .then(userDoc => {
          let filesArray = [];
          if (userDoc.data().fileSystem){
            userDoc.data().fileSystem.forEach((fileName) => {
              filesArray.push(fileName)
            })
          }
          setFiles(filesArray);
          setUserInformation({
            avatar: userDoc.data().avatar,
            name: userDoc.data().name,
            email: userDoc.data().email,
            admin: userDoc.data().admin,
            accountCreated: userDoc.data().accountCreated,
            surveyCompleted: userDoc.data().surveyCompleted,
            dashboard: userDoc.data().dashboardGrade,
            survey: userDoc.data().survey,
          })
          setLoading(false)
        })
        .catch((e) => {
          console.log(e)
        });
    } else {
      setLoading(false)
    }
  }

  var [state, dispatch] = React.useReducer(userReducer, {
    isAuthenticated: !!localStorage.getItem("id_token"),
  });

  return (
    <UserStateContext.Provider value={state}>
      <UserDispatchContext.Provider value={dispatch}>
        <UserContext.Provider value={{user, userInformation, Loading, setUserInformation, files, setFiles}}>
          {children}
        </UserContext.Provider>
      </UserDispatchContext.Provider>
    </UserStateContext.Provider>
  );
}

function useUserState() {
  var context = React.useContext(UserStateContext);
  if (context === undefined) {
    throw new Error("useUserState must be used within a UserProvider");
  }
  return context;
}

function useUserDispatch() {
  var context = React.useContext(UserDispatchContext);
  if (context === undefined) {
    throw new Error("useUserDispatch must be used within a UserProvider");
  }
  return context;
}

function useUserContext() {
  var context = React.useContext(UserContext);

  if (context === undefined) {
    throw new Error("useUserContext must be used within a UserProvider");
  }
  return context;
}

export { UserProvider, useUserState, useUserDispatch, loginUser, signOut, useUserContext, firebaseUpload, createUser, resetPassword };

// ###########################################################

function createUser (dispatch, email, password, name, history, setIsLoading, setError) {
  auth
    .createUserWithEmailAndPassword(email, password)
    .then(userCridentials => {
      setError(null);
      setIsLoading(false);
      addUserDoc(userCridentials.user.uid, userCridentials.user.email, name, dispatch);
    })
};

function addUserDoc(userUID, userEmail, name, dispatch) {
  firestore
    .collection('Users')
    .doc(userUID)
    .set({
      name: name,
      email: userEmail,
      surveyCompleted: false,
      accountCreated: Timestamp,
    })
    .then(() => {
      dispatch({ type: 'LOGIN_SUCCESS'});
    })
};

function loginUser (dispatch, login, password, history, setIsLoading, setError) {
  setError(false);
  setIsLoading(true);


  auth
    .signInWithEmailAndPassword(login, password)
    .then(() => {
      // localStorage.setItem('id_token', 1);
      setError(null);
      setIsLoading(false);
      dispatch({ type: 'LOGIN_SUCCESS'});
      // history.push('/app');
    })
    .catch(error => {
      // dispatch({ type: 'LOGIN_FAILURE'});
      setError(true);
      setIsLoading(false);
    });
  
  auth
    .onAuthStateChanged(function(user) {
      if(user){
        user.getIdToken().then(function(data) {
          localStorage.setItem('id_token', data);
          localStorage.setItem('user_uid', user.uid);
        });
      } else{
        console.log('no user');
      }
    });
};

function signOut(dispatch, history) {
  auth
    .signOut()
    .then(() => {
      localStorage.removeItem("id_token");
      localStorage.removeItem("currentProfile");
      localStorage.removeItem("user_uid");
      localStorage.removeItem("file");
      dispatch({ type: "SIGN_OUT_SUCCESS" });
      history.push("/login");
    })
}

function firebaseUpload(file) {
  var storageRef = storage.ref().child(localStorage.getItem('user_uid') + '/' + file.name)
  storageRef.put(file)
    .then(() =>{
      firestore
        .collection('Users')
        .doc(localStorage.getItem('user_uid'))
        .update({
          fileSystem: arrayUnion.FieldValue.arrayUnion(file.name)
        })
        .then(() => {

        })

    });
};

function resetPassword(email, handleClose, setEmailReset, setResetMessage) {
  auth
    .sendPasswordResetEmail(email)
    .then(() => {
      setEmailReset('')
      setResetMessage('An email has been set to the emial address provided. If you do not receive an email, please enter a valid email')
    })
    .catch(() => {
      setResetMessage('Please enter a valid email')
    })
};
